import axios from 'services/axios'
import {
  API_TICKET_COMMENT_CREATE,
  API_TICKET_COMMENT_UPLOAD_FILE,
  API_TICKET_COMMENT_DOWNLOAD_FILE,
} from 'constants/endpoints'

/**
 * Create comment
 *
 * @param {Object} { ticketId, content, files = [] }
 * @returns
 */
export const createTicketComment = async ({
  ticketId,
  content,
  files = [],
}) => {
  try {
    const { data } = await axios.post(API_TICKET_COMMENT_CREATE, {
      content,
      ticketingId: ticketId,
      attachmentFileNames: files.map((x) => x.name),
    })

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Upload file comment
 *
 * @param {File} file
 * @returns {Object}
 */
export const uploadTicketCommentAttachment = async ({
  file,
  onUploadProgress,
}) => {
  try {
    const { data } = await axios.post(
      API_TICKET_COMMENT_UPLOAD_FILE,
      {
        file,
        uploadType: 'comment',
      },
      {
        onUploadProgress,
      }
    )

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Download comment file
 *
 * @param {Object} { fileName, commentId }
 * @return {Object}
 */
export const downloadTicketCommentAttachment = async ({
  fileName,
  commentId,
}) => {
  try {
    return await axios.get(API_TICKET_COMMENT_DOWNLOAD_FILE, {
      params: {
        fileName,
        commentId,
      },
      downloadFile: true,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
